import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AWS from "aws-sdk";

const VALID_FILE_TYPES = ["image/png", "image/jpeg", "image/jpg", "video/mp4"];

const PageTitle = ({
  pageHeading,
  previousPath,
  motherMenu,
  activeMenu,
  isButton,
  action2,
  action,
  pathBack,
  refresh,
}) => {
const navigate = useNavigate();
  const s3 = new AWS.S3();

  return (
    <div  className="page-titles d-flex align-items-center justify-content-between  inpp">
      <div className="" >
        <ol 
          className="breadcrumb"
          style={{padding: isButton ? "" : "0.5rem 0" }}
        >
          <li className="breadcrumb-item" >
          {pathBack ? (
              <span
                style={{ cursor: "pointer", color: "#A60000", fontWeight: "bold" }}
                onClick={() => navigate(-1)}  
              >
                {motherMenu}
              </span>
            ) : (
              <Link  to={previousPath}>{motherMenu}</Link>
            )}
          </li>
          <li className="breadcrumb-item active" style={{color:"#A60000"}}>{activeMenu}</li>
        </ol>
      </div>
      <div className="d-flex align-items-center ">
        
      </div>
    </div>
  );
};

export default PageTitle;
